import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ModernTestExamPreviewComp from "./Component/ModernTestExamPreviewComp"


const ModernTestExamPreview =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ModernTestExamPreviewComp />
        </div>
        <Footer />
        </>
    )
}

export default ModernTestExamPreview